
export default [
    {
        path: '/manage/shopGift',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '产品赠品',
            keepAlive: false
        }
    },   
];
  